import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip } from "./kit";

/// 5 Kas: Kar / zarar — gelir (magaza, web, coin bank) eksi maas defteri
const usd = (n) => "$" + (Number(n) || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const KarZarar = () => {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.karZarar(days).then((r) => setD(r?.status ? r : { hata: r?.message || "Yüklenemedi" }));
  }, [days]);
  const maxSeri = Math.max(1, ...((d?.seri || []).map((x) => x.usd)));
  return (
    <div className="mainDashboard">
      <PageHead
        title="Kâr / Zarar"
        sub="Gelir − mağaza kesintisi − iade − yayıncı/ajans hakları"
        right={
          <select className="form-control" style={{ width: 150 }} value={days} onChange={(e) => setDays(Number(e.target.value))}>
            {[1, 7, 30, 90, 365].map((x) => (
              <option key={x} value={x}>Son {x} gün</option>
            ))}
          </select>
        }
      />
      {!d ? (
        <div className="badu-empty">Yükleniyor…</div>
      ) : d.hata ? (
        <div className="badu-empty">{d.hata}</div>
      ) : (
        <>
          <div className="badu-bento" style={{ marginBottom: 12 }}>
            <div className="badu-tile"><p className="badu-lbl">Brüt gelir</p><div className="badu-val">{usd(d.brut)}</div></div>
            <div className="badu-tile"><p className="badu-lbl">Net gelir (kesinti sonrası)</p><div className="badu-val">{usd(d.net)}</div></div>
            <div className="badu-tile"><p className="badu-lbl">İade</p><div className="badu-val">{usd(d.iade.usd)} <span style={{ fontSize: 13 }}>({d.iade.adet})</span></div></div>
            <div className="badu-tile"><p className="badu-lbl">Yayıncı / ajans hakları</p><div className="badu-val">{usd(d.giderTop)}</div></div>
            <div className="badu-tile">
              <p className="badu-lbl">Kalan</p>
              <div className="badu-val" style={{ color: d.kalan >= 0 ? "#059669" : "#DC2626" }}>{usd(d.kalan)}</div>
              <Chip kind={d.oran >= d.hedef ? "ok" : "bad"}>%{d.oran.toFixed(1)} · hedef %{d.hedef}</Chip>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h6 style={{ fontWeight: 700 }}>Gelir</h6>
              <div className="table-responsive">
                <table className="table">
                  <thead><tr><th>Kaynak</th><th>Adet</th><th>Brüt</th><th>Kesinti</th><th>Net</th><th>Coin</th></tr></thead>
                  <tbody>
                    {d.gelir.map((g) => (
                      <tr key={g.kaynak}>
                        <td>{g.kaynak}{g.not ? <div style={{ fontSize: 11, color: "#9CA3AF" }}>{g.not}</div> : null}</td>
                        <td>{g.adet}</td>
                        <td>{usd(g.brut)}</td>
                        <td>{usd(g.kesinti)}</td>
                        <td><b>{usd(g.net)}</b></td>
                        <td>{(g.coin || 0).toLocaleString("tr-TR")}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h6 style={{ fontWeight: 700 }}>Gider (maaş defteri)</h6>
              <div className="table-responsive">
                <table className="table">
                  <thead><tr><th>Kalem</th><th>Kayıt</th><th>Tutar</th></tr></thead>
                  <tbody>
                    {d.gider.map((g) => (
                      <tr key={g.kalem}><td>{g.kalem}</td><td>{g.adet}</td><td>{usd(g.usd)}</td></tr>
                    ))}
                    {!d.gider.length && <tr><td colSpan={3}><div className="badu-empty">Bu dönemde kayıt yok.</div></td></tr>}
                  </tbody>
                </table>
              </div>
              <div className="d-flex" style={{ gap: 10, flexWrap: "wrap", marginTop: 6 }}>
                <Chip kind="wait">Yayıncıların elindeki elmas: {(d.elmasBorc?.elmas || 0).toLocaleString("tr-TR")} ≈ {usd(d.elmasBorc?.usd)}</Chip>
                <Chip kind="wait">Maaş cüzdanlarında bekleyen: {usd(d.maasBorc)}</Chip>
              </div>
              <div style={{ fontSize: 12, color: "#6B7280", marginTop: 8 }}>{d.not}</div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h6 style={{ fontWeight: 700 }}>Günlük mağaza + web satışı</h6>
              <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 140, overflowX: "auto" }}>
                {d.seri.map((x) => (
                  <div key={x._id} title={`${x._id}: ${usd(x.usd)}`} style={{ flex: "1 0 10px", minWidth: 10, background: "#6366F1", borderRadius: "3px 3px 0 0", height: `${Math.max(2, (x.usd / maxSeri) * 130)}px` }} />
                ))}
              </div>
              {!d.seri.length && <div className="badu-empty">Satış yok.</div>}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default KarZarar;
